import { render, staticRenderFns } from "./Consignatarios.vue?vue&type=template&id=4fa332f5&"
import script from "./Consignatarios.vue?vue&type=script&lang=js&"
export * from "./Consignatarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports